import { type FeatureExtractionContextType } from '@mobile-mapping/providers';
import { type PointCloudCrsAuthoring } from '@trimble/geospatial';

export interface CreatePointCloudCrsAuthoringParams {
  readonly context: FeatureExtractionContextType;
  readonly csib: string;
}

export interface PointCloudCrsAuthoringHandle {
  getPointCloudCrsAuthoring(): PointCloudCrsAuthoring | undefined;
}

// Scene X,Y,Z are already in the point cloud CRS, so authoring is the identity
// as long as this session's CSIB is the one the active CRS was derived from.
export function createPointCloudCrsAuthoring(
  params: CreatePointCloudCrsAuthoringParams
): PointCloudCrsAuthoringHandle {
  const { context, csib } = params;
  return {
    getPointCloudCrsAuthoring: () => {
      const active = context.activeCrs();
      if (
        active === undefined ||
        active.pointCloudId === undefined ||
        active.csib64 !== csib
      ) {
        return undefined;
      }
      const { crsUrn } = active;
      if (crsUrn === undefined) {
        return undefined;
      }
      return { toCoordinates: (x, y, z) => [x, y, z], crsUrn };
    },
  };
}
